import { escapeRegExp } from 'lodash';

export class UserRegExp extends RegExp {
  constructor(userRegex: string, flags = 'i') {
    super(escapeInvalidRegex(userRegex, flags), flags);
  }
}

function escapeInvalidRegex(userRegex: string, flags: string): string {
  try {
    new RegExp(userRegex, flags);
    return userRegex;
  } catch {
    return escapeRegExp(userRegex);
  }
}
